import { useEffect, useState } from "react";
import {
    redirect,
    Navigate
  } from "react-router-dom";
import base_url from "../base_url";
import {localStorageUserKey, localStorageAdminKey} from '../local_storage_vars';
import { smartStorage } from "../smart_storage";
import SomethingWentWrong from "../pages/something_wentwrong";

const MemberShipRequired = ({children})=>{
    const [HasMembership,setHasMembership] = useState(true)
    const [isError,setError] = useState(false)
    const [is_loading,setLoading] = useState(true)
    const user = smartStorage.get(localStorageUserKey);

    const CheckMembership = ()=>{
        //we will uncomment this code when we introduce membership plans
        // fetch(base_url+'/apis/user_membership/user-membership-details',{
        //     method:'GET',
           
        //     headers:{
        //         "x-api-key":process.env.REACT_APP_API_KEY,
        //         "authorization":user
        //     }
        //   })
        //   .then(res=>res.json())
        //   .then(response=>{
           
        //    if(response.found == false){
            
        //     setHasMembership(false)
        //    }else{
        //     setHasMembership(true)

        //    }

        //    setLoading(false)
        //   })
        //   .catch(error=>{
        //   setError(true)
        //    setLoading(false)


        //   })

           setHasMembership(true); //comment this line when we introduce membership plans
    }

    useEffect(()=>{
        CheckMembership();
    },[])

    if(isError){
        return  <SomethingWentWrong />
    }
    
    //when we introduce membership plans, we will uncomment this code and use it to check if user has membership or not
    // if(!HasMembership && isError == false){
    //     return <Navigate to={'/memberships'} />
    // }else if(HasMembership && is_loading == false && isError == false){
    //     return children
    // }
    return children; //comment out this line when we introduce membership plans and uncomment the above code
}

export default MemberShipRequired